/**
 * Web shim over `@command-center/shared`'s OPERATOR_ROSTER. The shared
 * package is the canonical source — this file preserves the historical
 * `OPERATORS` / `operatorName` API for the Surface call sites
 * (`surface.tsx`, `surface-trigger.tsx`) without changing them.
 *
 * The Slice E Create modal also reads from here (via the shared roster)
 * to populate the assignee dropdown.
 */

import {
  OPERATOR_ROSTER,
  operatorByEmail,
  type Operator as SharedOperator,
} from "@command-center/shared";

export type Operator = { email: string; name: string };

export const OPERATORS: readonly Operator[] = OPERATOR_ROSTER.map(
  (o: SharedOperator) => ({ email: o.email, name: o.displayName }),
);

/** Friendly name for an operator email; falls back to the email itself. */
export function operatorName(email: string | null): string {
  if (!email) return "—";
  const found = operatorByEmail(email);
  return found ? found.displayName : email;
}
